import * as React from "react";
import {cx} from "emotion";

import "./braintree-form.scss";

import {bindInput}      from "@Common/react/bind-input";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Select}         from "@Common/ui-components/heavy/common/design2/select/select";

export const BraintreeForm = ({addXdQaNamePrefix, next, recaptchaToken}) => cs(
    consumeContext("braintree"),
    ["braintreeForm", ({braintree}, next) => braintree.renderForm({next, recaptchaToken})],
    ({braintreeForm}) => next({
        isValid: braintreeForm.isValid,
        tokenize: braintreeForm.tokenize,
        render: ({form, showErrors}) => cs(
            consumeContext("countryCodes"),
            ({countryCodes}) => {

                const renderBtField = ({id, label, xdQaName=undefined}) => {
                    return (
                        <div className={cx("form-group", id, {"has-error": showErrors && !braintreeForm.getFieldState(id)?.valid})}>
                            <div className="control-label" xd-qa-type="label" xd-qa-name={addXdQaNamePrefix(xdQaName)}>{label}</div>
                            <div
                                className="form-input"
                                id={id}
                                xd-qa-type="text_field"
                                xd-qa-name={addXdQaNamePrefix(xdQaName)}
                            />
                        </div>
                    );
                };

                const renderFieldI = ({path, label, placeholder=undefined, xdQaName=undefined}) => renderField({
                    path, label,
                    renderControl: (field) => (
                        <input
                            {...{placeholder}}
                            {...bindInput(field.state)}
                            xd-qa-type="text_field"
                            xd-qa-name={addXdQaNamePrefix(xdQaName)}
                        />
                    ),
                    xdQaName,
                });
                const renderField = ({path, label, renderControl, xdQaName=undefined}) => {
                    const field = form.field(path);
                    const error = field.error;

                    return (
                        <div className={cx("form-group", path, {"has-error": !!error})}>
                            <div className="control-label" xd-qa-type="label" xd-qa-name={addXdQaNamePrefix(xdQaName)}>{label}</div>
                            {renderControl(field)}

                            {/*{error && (*/}
                            {/*    <div className="error-message">*/}
                            {/*        {error.getMessage()}*/}
                            {/*    </div>*/}
                            {/*)}*/}
                        </div>
                    );
                };

                return (
                    <div className="braintree-form-5g5">
                        {braintreeForm.loading && (
                            <div className="loading">
                                <i className="fa fa-spinner fa-pulse"/>
                                Loading Braintree...
                            </div>
                        )}

                        {braintreeForm.initException && (
                            <div className="error">
                                <b>
                                    Error initializing payment processor
                                    {braintreeForm.initException.message && ` (${braintreeForm.initException.message})`}
                                </b>.{" "}
                                Please refresh your browser and try again.
                            </div>
                        )}

                        {braintreeForm.initFields({
                            getSelector: (name) => `.braintree-form-5g5 #${name}`,
                            style: {
                                input: {
                                    "font-size": "13px",
                                },
                            },
                        })}

                        {renderBtField({
                            id: "number",
                            label: "CARD NUMBER",
                            xdQaName: "CARD NUMBER",
                        })}
                        {renderFieldI({
                            path: "cardHolderName",
                            label: "NAME (as it appears on the card)",
                            xdQaName: "NAME",
                        })}
                        <div className="expiry-line">
                            {renderBtField({
                                id: "expirationDate",
                                label: "EXPIRY DATE",
                                xdQaName: "EXPIRY DATE",
                            })}

                            {renderBtField({
                                id: "cvv",
                                label: "CVV CODE",
                                xdQaName: "CVV CODE",
                            })}
                        </div>

                        <div className="separator"/>

                        {renderFieldI({
                            path: "streetAddress",
                            label: "BILLING ADDRESS",
                            xdQaName: "BILLING ADDRESS",
                        })}

                        <div className="city-line">

                            {renderFieldI({
                                path: "city",
                                label: "CITY",
                                xdQaName: "CITY",
                            })}
                            {renderFieldI({
                                path: "stateProvince",
                                label: "STATE / PROVINCE",
                                xdQaName: "STATE / PROVINCE"
                            })}
                        </div>
                        <div className="country-line">
                            {renderField({
                                path: "country",
                                label: "COUNTRY",
                                renderControl: (field) => <>
                                    {Select({
                                        list: Object.keys(countryCodes||{}),
                                        // list: [
                                        //     "US",
                                        //     ...Object.keys(countryCodes||{}).filter((code) => code !== "US"),
                                        // ],
                                        itemToLabel: (code) => countryCodes[code],
                                        isSelected: (code) => field.state.value === code,
                                        onChange: (countryCode) => {
                                            field.state.onChange(countryCode);
                                            form.field("stateProvince").state.onChange(null);
                                        },
                                        xdQaName: addXdQaNamePrefix("COUNTRY"),
                                    })}
                                </>,
                                xdQaName: "COUNTRY",
                            })}
                            {renderFieldI({
                                path: "zip",
                                label: "POSTAL CODE",
                                xdQaName: "POSTAL CODE",
                            })}
                        </div>
                    </div>
                );
            },
        ),
    }),
);


